import api from "../api/axios";

export const VIEW_GENDER_QUERY_KEY = ["view-gender"];
export const GENDER_QUERY_KEY = ["gender"];

export interface CreateGenderPayload {
  name: string;
  status: number;
}
export interface UpdateGenderPaylod extends CreateGenderPayload {}

export const genderService = {
  getAllViewGender: async () => {
    const response = await api.get(`api/view-gender`);
    return response.data;
  },
  getViewGenderByCode: async (code: string) => {
    const response = await api.get(`api/view-gender/${code}`);
    return response.data;
  },
  getAllGender: async () => {
    const response = await api.get(`api/genders`);
    return response.data;
  },
  getGenderById: async (id: string) => {
    const response = await api.get(`api/genders/${id}`);
    return response.data;
  },
  createGender: async (payload: CreateGenderPayload) => {
    const response = await api.post(`api/genders`, payload);
    return response.data;
  },
  updateGender: async (id: string, payload: UpdateGenderPaylod) => {
    const response = await api.put(`api/genders/${id}`, payload);
    return response.data;
  },
  toggleStatus: async (id: string) => {
    const response = await api.put(`api/genders/${id}/toggle-status`);
    return response.data;
  },
};
